import { CloseButton, Col, Container, Row } from "react-bootstrap";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import "../css/players.css";
import { useEffect, useRef, useState } from "react";
import env from "../../../../env";

const Players = ({ index = 0, music, buttonBlockChild }) => {
  document.body.classList.add("visualized");
  const [state, setState] = useState(true);
  const [indexPlayerPre, setIndexPlayerPre] = useState(index);
  const [indexPlayer, setIndexPlayer] = useState(index);
  const [buttonPlayerStart, setButtonPlayerStart] = useState(null);
  const [buttonPlayerEnd, setButtonPlayerEnd] = useState(null);
  const playerRef = useRef(null);

  if (indexPlayerPre !== index) {
    setIndexPlayerPre(index);
    setIndexPlayer(index);
  }

  if (index !== indexPlayer && state) {
    setIndexPlayer(index);
  }

  const ClickPrevious = () => {
    setState(false);
    if (music.length >= 2) {
      setIndexPlayer(indexPlayer === 0 ? music.length - 1 : indexPlayer - 1);
    }
  };

  const ClickNext = () => {
    setState(false);
    if (music.length >= 2) {
      if (music.length - 1 === indexPlayer) {
        setIndexPlayer(0);
      } else {
        setIndexPlayer(indexPlayer + 1);
      }
    }
  };
  const fetchIdComponents = () => {
    const button_open_player = document.getElementById("button_open_player");
    const container_player = document.getElementById("container_player");
    setButtonPlayerStart(button_open_player);
    setButtonPlayerEnd(container_player);
  };

  const addPlayer = () => {
    buttonPlayerEnd.classList.replace(
      "container_player_cover",
      "container_player"
    );
    document.body.classList.add("visualized");
  };

  const removePlayer = () => {
    if (playerRef.current) {
      playerRef.current.audio.current.pause();
      playerRef.current.audio.current.currentTime = 0;
    }
    buttonPlayerEnd.classList.replace(
      "container_player",
      "container_player_cover"
    );
    document.body.classList.remove("visualized");
  };

  const buttonParent = () => {
    buttonBlockChild(false);
  };

  useEffect(() => {
    fetchIdComponents();
  }, []);

  if (buttonPlayerStart) {
    buttonPlayerStart.addEventListener("click", addPlayer());
  }

  return (
    <Container
      id="container_player"
      fluid
      className="p-0 position-fixed text_index visualized container_player w-100 bg-custom-player "
    >
      <Container className=" p-0 w-100 h-100 ">
        <Row className="audio-player-text text-white pt-3 pb-1">
          <Col xs={12} sm={6} className=" p-0 d-flex align-self-center">
            <h4 className="title-player m-0 w-100 text-center text-sm-start">
              {music[indexPlayer].name}
            </h4>
          </Col>
          <Col
            xs={{ order: "first", span: 12 }}
            sm={{ order: "last", span: 6 }}
            className=" d-flex align-items-center justify-content-end pb-2 pe-4"
          >
            <CloseButton
              className="bg-white p-2"
              onClick={() => {
                removePlayer();
                buttonParent();
              }}
            />
          </Col>
        </Row>
        <div className=" border-3 border-bottom"></div>
        <AudioPlayer
          ref={playerRef}
          className="custom-audio-player bg-custom-player py-4"
          autoPlay={true}
          src={env.BACKEND_BASE_URL + music[indexPlayer].url}
          showSkipControls={true}
          autoPlayAfterSrcChange={true}
          onClickPrevious={ClickPrevious}
          onClickNext={ClickNext}
        />
      </Container>
    </Container>
  );
};
export default Players;
